<template>
	<div class="stats">
		<p v-if="is('error')">{{ errorMsg }}</p>
		<p v-else-if="is('loading')">Loading...</p>
		<table v-else>
			<tbody>
				<EventStatsRow v-for="stat in statRows" :key="stat.key" v-bind="stat" />
			</tbody>
		</table>
	</div>
</template>

<script>
import IconPlayers from 'mdi-vue/AccountGroup'
import IconGames from 'mdi-vue/GamepadVariant'
import IconPlaytime from 'mdi-vue/Timer'
import EventStatsRow from '@/components/EventStatsRow'

import { StatsProvider } from '@/lib/dataProvider'
import state from '@/mixins/state'

const toFixed = (n, d = 2) => Math.floor(n * 10 ** d) / 10 ** d
const toSeconds = n => {
	const seconds = n / 1000
	const m = Math.floor(seconds / 60)
	const s = toFixed(n % 60, 1)
	return m ? `${m}m ${s}s` : `${s}s`
}

const StatFormat = {
	uniquePlayers: {
		label: 'Unique players',
		formatter: toFixed,
		icon: IconPlayers,
	},
	totalGamesPlayed: {
		label: 'Total games played',
		formatter: toFixed,
		icon: IconGames,
	},
	avgGamesPerPlayer: {
		label: 'Average games per player',
		formatter: toFixed,
	},
	mostGamesByPlayer: {
		label: 'Most games by one player',
		formatter: toFixed,
	},
	averagePlaytime: {
		label: 'Average game length',
		formatter: toSeconds,
		icon: IconPlaytime,
	},
	longestGame: {
		label: 'Longest session',
		formatter: toSeconds,
	},
}

export default {
	name: 'EventStats',
	props: {
		event: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			errorMsg: '',
			stats: {
				uniquePlayers: 0,
				totalGamesPlayed: 0,
				avgGamesPerPlayer: 0,
				mostGamesByPlayer: 0,
				averagePlaytime: 0,
				longestGame: 0,
			},
		}
	},
	computed: {
		statRows() {
			return Object.entries(this.stats).map(([key, value]) => {
				const { label, icon, formatter } = StatFormat[key]
				return {
					key,
					label,
					icon,
					value: formatter ? formatter(value) : value,
				}
			})
		},
	},
	methods: {
		async getStats(event) {
			this.setState('loading')
			try {
				this.stats = await StatsProvider.get(event)
				this.setState('idle')
			} catch (err) {
				switch (err.code) {
					case 404:
						this.errorMsg = err.message
						break
					default:
						this.errorMsg = 'Error loading stats.'
						break
				}
				this.setState('error')
			}
		},
	},
	created() {
		this.getStats(this.event)
	},
	mixins: [state()],
	components: {
		EventStatsRow,
	},
}
</script>

<style lang="scss" scoped>
table {
	width: 100%;
	max-width: 24rem;
}
</style>
